import React from 'react';
import {useTranslation} from 'react-i18next';

import {Close} from '@ELib/assets/images';
import {EIconSmallButton} from '@ELib/components/EButtons';
import {StyledETableRefreshIndicator} from '@ELib/components/ETable/styles';

export function RefreshIndicator({
  text,
  onRefresh,
  onClose,
}: {
  text?: string;
  onRefresh: () => void;
  onClose: () => void;
}): React.ReactElement {
  const {t} = useTranslation('lib');

  return (
    <StyledETableRefreshIndicator onClick={onRefresh}>
      <p>{text ? text : t('reload-indicator')}</p>
      <EIconSmallButton onClick={onClose}>
        <Close />
      </EIconSmallButton>
    </StyledETableRefreshIndicator>
  );
}
